import React from 'react';

import Icon from '../Icon';

interface DrawerHandleProps {
  onClick: () => void;
}

export const DrawerHandle: React.FC<DrawerHandleProps> = ({ onClick }) => {
  return (
    <div data-test-id="navbar-resizer" id="navbar-resizer" onClick={onClick}>
      <Icon kind="resizer" size={28} color="#b3e6f8" />
    </div>
  );
};
